import useApolloClient from '../hooks/useApolloClient';
import { Route, Switch } from 'react-router-dom';
import Users from '../pages/users/Users';
import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { ModeProvider } from '../hooks/useMode';
import Companies from './admin/pages/companies/Companies';
import Dashboard from './admin/pages/dashboard/Dashboard';
import WaterSuppliers from './admin/pages/waterSuppliers/WaterSuppliers';
import WaterHazards from './admin/pages/waterHazards/WaterHazards';
import SurveyTemplates from './admin/pages/surveyTemplates/SurveyTemplates';
import SurveyTemplateEditor from './admin/pages/surveyTemplates/SurveyTemplateEditor';
import Makes from './admin/pages/makesAndModels/MakesAndModels';
import Plans from './admin/pages/plans/Plans';
import Activity from '../pages/activity/Activity';
import NotificationSettings from './common/pages/settings/NotificationSettings';
import ActivityHandler from '../components/ActivityFeed/ActivityHandler';

const Admin = () => {
  return (
    <ApolloProvider client={useApolloClient('admin')}>
      <ModeProvider value="admin">
        <ActivityHandler />
        <Switch>
          <Route path="/admin/activity" component={Activity} />
          <Route
            path={['/admin/companies/:id', '/admin/companies']}
            component={Companies}
          />
          <Route
            path={['/admin/water-suppliers/:id', '/admin/water-suppliers']}
            component={WaterSuppliers}
          />
          <Route
            path={['/admin/users/:id', '/admin/users']}
            component={Users}
          />
          <Route
            path={['/admin/makes/:id', '/admin/makes']}
            component={Makes}
          />
          <Route
            path={['/admin/plans/:id', '/admin/plans']}
            component={Plans}
          />
          <Route
            path={['/admin/water-hazards/:id', '/admin/water-hazards']}
            component={WaterHazards}
          />
          <Route
            path="/admin/survey-templates/:id"
            component={SurveyTemplateEditor}
          />
          <Route path="/admin/survey-templates" component={SurveyTemplates} />
          <Route
            path="/admin/notification-settings"
            component={NotificationSettings}
          />
          <Route path="/admin" component={Dashboard} />
        </Switch>
      </ModeProvider>
    </ApolloProvider>
  );
};

export default Admin;
